<div class="application" [ngClass]="{'application--expanded': isVisibleDetails && !isCloningError()}">
  <div class="cell shrink cell--active" *ngIf="showActiveApp">
    <button (click)="setDefault()" *ngIf="!showCloningView()">
      <svg-icon class="is-default" *ngIf="isDefault()" src="/assets/icons/radio-checked.svg"></svg-icon>
      <svg-icon class="is-default" *ngIf="!isDefault()" src="/assets/icons/radio-no-checked.svg"></svg-icon>
    </button>
  </div>
  <div class="cell cell--name" *ngIf="!isEditing" [attr.data-test-application-name]="application.name">
    <div class="cell--name-block">
      <svg-icon class="menu-icon" src="/assets/icons/menu-right.svg" (click)="toggleVisibleDetails()"
        *ngIf="!isCloningError()" [ngClass]="{'menu-icon--expanded': isVisibleDetails && !isCloningError()}">
      </svg-icon>
      <div class="cell--name-title" (click)="toggleVisibleDetails()" [uiTooltip]="application.name"
        uiTooltipPosition="bottom" [ngClass]="{'cell--name-title--expanded': isVisibleDetails && !isCloningError()}">
        {{ application.name }}
      </div>
      <button class="edit-btn" (click)="edit()">
        <svg-icon src="/assets/icons/edit.svg"></svg-icon>
      </button>
    </div>
    <!--div class="cell--name-descr" *ngIf="application.tenant">
    <span uiTooltip="Tenant" uiTooltipPosition="bottom">{{ application.tenant }}</span> /
    <span uiTooltip="Project" uiTooltipPosition="bottom">{{ application.project }}</span>
  </div-->
  </div>
  <div class="cell cell--name-edit" *ngIf="isEditing" [attr.data-test-application-name]="application.name">
    <input type="text" name="name" #name class="name" [(ngModel)]="applicationName" (keydown.enter)="save()"
      [disabled]="!isEditing" (load)="focus(name)" maxlength="40" autofocus />
    <button (click)="save()">
      <svg-icon src="/assets/icons/check.svg"></svg-icon>
    </button>
    <button (click)="cancel()">
      <svg-icon src="/assets/icons/cross-thing.svg"></svg-icon>
    </button>
  </div>

  <div class="cell cell--duplication-status" *ngIf="showCloningView()">
    <div class="cloning-error" *ngIf="application.clone.status === applicationCloneStatus.Error">
      <svg-icon class="error-icon" src="/assets/icons/failed.svg"></svg-icon>
      <span class="error-text">Duplication error</span>
    </div>
    <div class="cloning-status" *ngIf="showCloningStatus()">
      <ui-loader class="loader"></ui-loader>
      <span class="duplication-status">
        Duplication status:&nbsp;
        <span *ngIf="application.clone.status !== applicationCloneStatus.Added">
          {{ application.clone.status }} ({{ application.clone.progress }}%)
        </span>
        <span *ngIf="application.clone.status === applicationCloneStatus.Added">In Queue</span>
      </span>
    </div>
  </div>
  <!--TODO(Akryuchkov): Много дублирования-->
  <div class="cell--trash"
    *ngIf="serviceType === 'ic' && (!showCloningView() || application.clone.status === applicationCloneStatus.Error)">

    <button [ngClass]="{'duplicate-icon--disabled': !canDuplicate()}" (click)="copyApp($event)"
      [uiTooltip]="duplicateTooltip()" uiTooltipPosition="left">
      <svg-icon class="duplicate-icon" src="/assets/icons/duplicate.svg"></svg-icon>
    </button>
    <button [ngClass]="{'delete-icon--disabled': !canDelete()}" (click)="delete($event)" [class.disabled]="!canDelete()"
      [uiTooltip]="deleteTooltip()" uiTooltipPosition="left">
      <svg-icon class="delete-icon" src="/assets/icons/delete.svg"></svg-icon>
    </button>
  </div>

  <div class="cell--trash" *ngIf="serviceType === 'dc'">
    <button (click)="delete()" [ngClass]="{'delete-icon--disabled': !canDelete()}" [uiTooltip]="deleteTooltip()"
      uiTooltipPosition="left">
      <svg-icon class="delete-icon" src="/assets/icons/delete.svg"></svg-icon>
    </button>
  </div>
  <ui-loading *ngIf="isSaving"></ui-loading>
</div>
<div class="details" *ngIf="isVisibleDetails"
  [ngClass]="{'details--primary': showActiveApp, 'details--secondary': !showActiveApp}">
  <div class="details-item">
    <div class="details-item-title">ID</div>
    <div class="cell--id" [attr.data-test-application-id]="application.id" *ngIf="!showCloningView()">
      <span>{{ application.id }}</span>
      <button (click)="copy(application.id)" uiTooltip="Copy ID" uiTooltipPosition="bottom">
        <svg-icon src="/assets/icons/copy.svg"></svg-icon>
      </button>
    </div>
  </div>
  <div class="details-item">
    <div class="details-item-title">Token</div>
    <div class="cell--token" [attr.data-test-application-token]="application.token" *ngIf="!showCloningView()">
      <span>{{ tokenView() }}</span>
      <button (click)="showToken()" uiTooltip="Show token" uiTooltipPosition="bottom">
        <svg-icon src="/assets/icons/show-password.svg"></svg-icon>
      </button>
      <button (click)="copy(application.token)" uiTooltip="Copy token" uiTooltipPosition="bottom">
        <svg-icon src="/assets/icons/copy.svg"></svg-icon>
      </button>
      <button (click)="restoreToken()" uiTooltip="Reset token" uiTooltipPosition="bottom">
        <svg-icon src="/assets/icons/restore.svg"></svg-icon>
      </button>
      <ui-loading *ngIf="isTokenLoading"></ui-loading>
    </div>
  </div>
</div>

<ng-template #duplicated>
  <svg-icon class="check-icon" src="/assets/icons/check-circle.svg"></svg-icon>
  <span>Application copying started successfully.</span>
</ng-template>
